import {useEffect} from 'react';

const localStorageKey: string = 'scrollPosition';

export const useRestoreScrollOnReload = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const beforeUnloadHandler = () => {
            localStorage.setItem(localStorageKey, `${window.scrollY}`);
        }

        let counter = 5;
        const timerId = setInterval(() => {
            if (counter === 0) {
                clearInterval(timerId);
                return;
            }
            counter--;
            const scrollPosition = localStorage.getItem(localStorageKey);
            if (!scrollPosition) {
                clearInterval(timerId);
                return;
            }
            const scrollY = parseInt(scrollPosition, 10);
            if (scrollY) {
                window.scrollTo(0, scrollY);
                clearInterval(timerId);
                localStorage.removeItem(localStorageKey);
            }
        }, 500);

        window.addEventListener('beforeunload', beforeUnloadHandler);

        return () => {
            window.removeEventListener('beforeunload', beforeUnloadHandler);
        }
    }, []);
}